import { Reveal } from "./Reveal";
import { ABOUT } from "../lib/data";

export const Founder = () => (
  <section id="about" data-testid="about-section" className="relative overflow-hidden py-24 md:py-40 border-t border-white/5 bg-[#050505] scroll-mt-24">
    {/* subtle texture + restrained gold accents */}
    <div className="pointer-events-none absolute inset-0 opacity-70" style={{ background: "radial-gradient(circle at 50% 0%, rgba(212,175,55,0.10), transparent 55%)" }} />
    <div className="pointer-events-none absolute inset-x-0 top-1/2 -translate-y-1/2 flex justify-center">
      <span className="font-display font-black uppercase text-white/[0.03] tracking-tighter text-[26vw] leading-none select-none whitespace-nowrap">
        Good Shot
      </span>
    </div>

    <div className="relative z-10 mx-auto max-w-4xl px-5 md:px-10 text-center">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-8">About</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display font-black uppercase tracking-tight text-white text-4xl sm:text-5xl md:text-7xl leading-[0.9]">
          Built From Hospitality.
          <span className="block text-[#D4AF37] mt-2">Designed For Scale.</span>
        </h2>
      </Reveal>

      <div className="mt-10 md:mt-12 max-w-2xl mx-auto space-y-5">
        {ABOUT.body.map((p, i) => (
          <Reveal key={i} delay={0.18 + i * 0.08}>
            <p className="text-base md:text-lg text-white/65 font-light leading-relaxed">{p}</p>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.4}>
        <div className="mt-10 md:mt-12 flex flex-col items-center">
          <div className="w-12 h-px bg-[#D4AF37]/50 mb-6" />
          <div className="font-display font-bold uppercase tracking-[0.12em] text-white text-xl md:text-2xl">{ABOUT.name}</div>
          <div className="mt-2 text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">{ABOUT.role}</div>
        </div>
      </Reveal>

      <Reveal delay={0.48}>
        <div className="mt-14 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 border-t border-white/10 pt-10">
          {ABOUT.stats.map((s, i) => (
            <div key={i} data-testid={`about-stat-${i}`} className="text-center">
              <div className="font-display font-black text-[#D4AF37] text-xl sm:text-2xl md:text-4xl leading-none break-words">{s.value}</div>
              <div className="mt-3 text-[10px] md:text-[11px] uppercase tracking-[0.16em] text-white/50 leading-relaxed">{s.label}</div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
